import { OfferPreview } from "@justhome/api-core";
import { useMemo } from "react";

const useGetOffersWithLowestInterestRate = (
  offers: OfferPreview[] | undefined,
): Set<string> => {
  return useMemo(() => {
    const lowestInterestRate = offers
      ?.map((offer) => offer.interestRate as number)
      .filter((value) => value)
      .reduce((a, b) => Math.min(a, b), Number.MAX_SAFE_INTEGER);
    return new Set(
      offers
        ?.filter((offer) => offer.interestRate === lowestInterestRate)
        .map((offer) => offer.id!),
    );
  }, [offers]);
};

export default useGetOffersWithLowestInterestRate;
